import { FriendlyCaptchaSDK } from "@friendlycaptcha/sdk";

const SITEKEY = process.env.NEXT_PUBLIC_FRIENDLYCAPTCHA_SITEKEY;

// One SDK instance per page; the widget itself is created per submission.
let sdk: FriendlyCaptchaSDK | null = null;

/**
 * Runs a Friendly Captcha challenge headlessly and resolves with a one-time
 * response token to verify server-side. The widget is mounted off-screen,
 * started via the JS API, and destroyed once solved — so every submit path
 * (UI forms and WebMCP tools) works without a visible widget, mirroring the
 * previous invisible reCAPTCHA flow.
 */
export async function getFriendlyCaptchaToken(): Promise<string> {
  if (!SITEKEY) {
    throw new Error("NEXT_PUBLIC_FRIENDLYCAPTCHA_SITEKEY is not defined");
  }

  sdk ??= new FriendlyCaptchaSDK();

  // ponytail: off-screen (not display:none) so the widget's worker still runs.
  const element = document.createElement("div");
  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.top = "-9999px";
  document.body.appendChild(element);

  const widget = sdk.createWidget({
    element,
    sitekey: SITEKEY,
    startMode: "none",
  });

  try {
    return await new Promise<string>((resolve, reject) => {
      widget.addEventListener("frc:widget.complete", (e) =>
        resolve(e.detail.response)
      );
      widget.addEventListener("frc:widget.error", () =>
        reject(new Error("Friendly Captcha challenge failed"))
      );
      widget.start();
    });
  } finally {
    widget.destroy();
    element.remove();
  }
}
